import { NgModule, ModuleWithProviders } from '@angular/core';
import { TRANSLATION_PROVIDERS, TranslatePipe, TranslateService } from '../i18n';

@NgModule({
  declarations: [TranslatePipe],
  exports: [TranslatePipe]
})
export class TranslateModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: TranslateModule,
      providers: [TRANSLATION_PROVIDERS, TranslateService]
    }
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/i18n/translate.module.ts